module.exports = __webpack_public_path__ + "img/arrow-right.570d1c3e.svg";